module.exports = __webpack_public_path__ + "img/BP.527584d1.png";